"use client";
import { Button } from "@ui/components/core/Button";
import { useTranslations } from "next-intl";
import { useState } from "react";

interface LogoGridClientProps {
  expandAfter?: null | number;
  logoContainers: React.ReactNode[];
  shouldLimit: boolean;
}

export const LogoGridClient = ({ logoContainers, expandAfter, shouldLimit }: LogoGridClientProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const t = useTranslations("ClientKeys.Globals");

  const visibleContainers = shouldLimit && !isExpanded ? logoContainers.slice(0, expandAfter ?? 0) : logoContainers;

  return (
    <>
      <div className='grid grid-cols-2 gap-32 lg:grid-cols-4'>{visibleContainers}</div>

      {shouldLimit && (
        <div className='mt-32 flex justify-center'>
          <Button className='normal-case' onClick={() => setIsExpanded(!isExpanded)} variant='elevated'>
            {isExpanded ? t("view_less") : t("view_more")}
          </Button>
        </div>
      )}
    </>
  );
};
